import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import IncompletePassword from '../../assets/sign-up/check-incomplete-password.svg';
import ValidPassword from '../../assets/sign-up/check-complete-password.svg';
import { Text, Box, FormikTextInput } from '@stashinvest/ui';

const PasswordListItem = styled(Text)`
	padding-left: 1.6em;
	line-height: 1.6em;
	background: ${({ isValid }) =>
		isValid
			? `url(${ValidPassword}) 0 center no-repeat`
			: `url(${IncompletePassword}) 0 center no-repeat`};
`;

export class PasswordBox extends React.Component {
	static defaultProps = {
		type: 'password',
	};
	constructor() {
		super();
		this.state = {
			showValidations: true,
			containsLowercase: false,
			containsUppercase: false,
			containsNumber: false,
			isMinLength: false,
		};
		this.setValue = this.setValue.bind(this);
	}

	setValue(event) {
		const value = event.target.value;
		this.setState({
			containsLowercase: !!value.match(/[a-z]/g),
			containsUppercase: !!value.match(/[A-Z]/g),
			containsNumber: !!value.match(/[0-9]/g),
			isMinLength: value.length >= 8,
		});
	}

	render() {
		const {
			containsLowercase,
			containsUppercase,
			containsNumber,
			isMinLength,
		} = this.state;

		return (
			<div>
				<Box mb="l">
					<FormikTextInput
						{...this.props}
						handleChange={(e) => {
							this.setValue(e);
							this.props.handleChange(e);
						}}
					/>
				</Box>
				<div>
					<PasswordListItem small isValid={containsLowercase}>
						At least 1 lowercase letter
					</PasswordListItem>
					<PasswordListItem small isValid={containsUppercase}>
						At least 1 capital letter
					</PasswordListItem>
					<PasswordListItem small isValid={containsNumber}>
						At least 1 number
					</PasswordListItem>
					<PasswordListItem small isValid={isMinLength}>
						At least 8 characters
					</PasswordListItem>
				</div>
			</div>
		);
	}
}
PasswordBox.propTypes = {
	handleChange: PropTypes.func,
};
